export default __webpack_public_path__ + "static/media/homelogo.16d2ebb5.svg";